import styled, { css } from 'styled-components';
import type { Key } from 'react';
import Badge from '../Badge';

type TabType = 'buttons' | 'primary';

type TabItemsProps = {
  background?: string;
  type?: TabType;
};

type WrapperProps = {
  type?: TabType;
};

type TabContentProps = {
  active?: boolean;
  path?: Key;
};

type StyledTabItemProps = {
  active?: boolean;
  tabKey?: Key;
  type?: TabType;
};

export const Wrapper = styled.div<WrapperProps>`
  overflow: hidden;
`;

export const TabItems = styled.div<TabItemsProps>`
  display: flex;
  ${props => css`
    background: ${props.background || 'white'};
  `};
  ${props =>
    props.type === 'buttons' &&
    css`
      margin: 0 -4px;
    `};
`;

export const TabContent = styled.div<TabContentProps>`
  ${props =>
    !props.active &&
    css`
      display: none;
    `};
`;

export const StyledBadge = styled(Badge)`
  margin-left: 5px;
`;

export const StyledTabItem = styled.div.attrs({
  className: 'tabs__item',
})<StyledTabItemProps>`
  ${props =>
    props.type === 'primary' &&
    css<StyledTabItemProps>`
      display: inline-flex;
      align-items: center;
      font-size: 14px;
      padding: 10px 0 5px 0;
      margin: 0 16px;
      cursor: pointer;
      border-bottom: 8px solid transparent;
      transition: border-color 0.15s;
      ${props =>
        props.active &&
        css<StyledTabItemProps>`
          border-color: #2770ff;
        `};
    `};
  ${props =>
    props.type === 'buttons' &&
    css<StyledTabItemProps>`
      display: inline-flex;
      align-items: center;
      font-size: 14px;
      margin: 8px 4px;
      border-radius: 2px;
      padding: 5px 8px;
      background: white;
      cursor: pointer;
      ${props =>
        props.active &&
        css<StyledTabItemProps>`
          background: #7eaaff;
          color: white;
        `};
    `};
`;
